module.exports = __webpack_public_path__ + "static/SeeVita-06-ef2bd31e08ca5a466bd60d322a68ff23.png";